export const setProfileMapData = (state, action) => {
  state.countDetails = action.payload;
};

export const setPortCategory = (state, action) => {
  state.portCategory = action.payload;
};

export const setTabDetails = (state, action) => {
  state.tabDetails = action.payload;
};

export const setProfileRedirectionId = (state, action) => {
  state.profileRedirectionId = action.payload;
};

export const setIsFreightForwarder = (state, action) => {
  state.isFreightForwarder = action.payload;
};

export const setLogisticsCachingHandler = (state, action) => {
  state.logisticsCaching = action.payload;
};
